import React from 'react';
import './header.css';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {

  return (
    <header className="header">
      <div className="header-left">
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32">
                    <image xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACshmLzAAADbklEQVRYCd1Xz2sTURCeTdqSWPBioyQVxHrSixU9+AMv0oMI9aLgpSgYetCDh14FvYnY/gVKsWK9Su/2L2gVhYqnKh5MitYUPJhCk93nfPMy8W2ym2wTpODAZt/OmzffNzNv3m48Y3xDeyipPcQW6P+EgBYRdx0nTO1AQrtkZl4yM9eqNwKNKI2xA89jZAz/OQEG8X1fAkgPDBJwVfx6zerT6V0RSZwBExgKgoAADAHgj81NGR/M5Zp6EzBBJuqlHHZiFfODc6DbVa/tsI2VN8vL5vLkVZM/ctTszx2SC2PoXi8tqZmxa7r7pqTg1epvAUkNZcz0nbsCtv553eACMHSYu3hpwlQqP4VIEhIdCQR+XRwBHFGePnvelMulZpQAan2GDWyVhPURn4l4AoHP5bQEEBUcq4AQBLrjJ8dl7JYpZM9+2BHbRF+xBNQh0ovUakQK/nh2TvSYu//goZDQOdyxP57OzzvkdkOAGSsBRHlvZiYEsPZxTcBBTgmurK6EbEBKsyOZjMlCZAY09YgakahzJQXH2PUq2hXyLEBG1mCt7pG4vdCRACJ1nQAAkf0tCaeVATXl6AQrvpSsnXx7GSIJaKStBJAJgOMsaJXWOUSehEDkSZhK2bd0IZ+X46uytUX5fIEmrkxSsXhbdCfGT9HIgZHm8TY8vE/GN4vTVP76hbAGcnh0VO7qUx6cHw/t4TzbIWs4Qj5O0wSgW1NTVN4o08LLV/Tre5mePV+g1bfvKJvNhJYWmOSjJ7N04/o1OjY2Ri8WF+nTh/eE41leWFGnc1x/ahnQSkg70hmV+lApeD+gFLDFmiRtGJ0BxKV58VJ05twFqm5XJRpMbfMYMjRoX0wY79RqlM1wRtrsg+hXNfwjI3EZgF6zoBsK7aa6UOT6wBmADTKg7Wft23e/4nYk0EoC/Q/naEWkGucELnQLTkbMwQYvKEg3cPjvSsAlAaeoqxIBoF7QgYRKEnD4jt8DKCykUSu/7vNHB3/tkG3RDe6Kb6WSmKDV0KZWAv5YUduGSuvdeHRvlkAHAyUgi9gOn2ToabRoSAwD81w66pMsyn9D1z0DIZTGAy/mVMsnGjRCCB+IUX0etd7R9UbAcRDKkKtPOO7/n1EPUbvc+ifgeuth3D8BbCZcKu5YdR3uvRNQIJTALYM77gCsU38A2HRQFa/tL8sAAAAASUVORK5CYII=" x="0" y="0" width="32" height="32"/>
                  </svg>
        <h1 className="business-name">Alvero Software Solutions</h1>
      </div>
      <nav className="header-nav">
        <Link to="/" className="nav-link">
          Home
        </Link>
        <Link to="/about" className="nav-link">
          About
        </Link>
        <Link to="/demos" className='nav-link'>Demos</Link>
        <div className="nav-dropdown">
          <button className="nav-dropdown-button">Services</button>
          <div className="nav-dropdown-content">
            <Link to="/Services/WebDevelopment">Web Development</Link>
            <Link to="/Services/CustomSoftware">Custom Software</Link>
          </div>
        </div>
        <Link to='/contact' className='nav-link'>Contact</Link>
      </nav>
    </header>
  );
};

export default Header;
